// extracted by mini-css-extract-plugin
export default {"base":"Processing_base__BEmyk","isVisible":"Processing_isVisible__rWNvq","spinner":"Processing_spinner__8kyYC"};